import React from "react";
import AppContextProvider from "@magento/peregrine/lib/context/app";
import CartContextProvider from "../context/cart";
import CatalogContextProvider from "@magento/peregrine/lib/context/catalog";
import CheckoutContextProvider from "@magento/peregrine/lib/context/checkout";
import ErrorContextProvider from "@magento/peregrine/lib/context/unhandledErrors";
import UserContextProvider from "@magento/peregrine/lib/context/user";
import BookTableContextProvider from "../context/bookTable";
import AmSocialLoginProvider from "@Components/SocialLogin/context";
import { CouponProvider } from "../context/coupon";
import { MenuTypeConflictProvider } from "../context/menuTypeConflict";

/**
 * List of essential context providers that are required to run Peregrine
 *
 * @property {React.Component[]} contextProviders
 */
const contextProviders = [ErrorContextProvider, AppContextProvider, UserContextProvider, CatalogContextProvider, CartContextProvider, CheckoutContextProvider, BookTableContextProvider, AmSocialLoginProvider, CouponProvider, MenuTypeConflictProvider];
const PeregrineContextProvider = _ref => {
  let {
    children
  } = _ref;
  return contextProviders.reduceRight((memo, ContextProvider) => {
    return /*#__PURE__*/React.createElement(ContextProvider, null, memo);
  }, children);
};
export default PeregrineContextProvider;